import { Pie } from 'vue-chartjs'

export default{
    props:['chartdata','options'],
    extends: Pie,
    watch: {
        chartdata(){
            this.renderChart(this.chartdata, this.options)
        }
    }
}